import React, { useEffect } from 'react';

function ImageModal({ imageSrc, pageNumber, onClose }) {
  useEffect(() => {
    const handleKeyDown = (e) => {
      if (e.key === 'Escape') {
        onClose();
      }
    };
    document.addEventListener('keydown', handleKeyDown);
    return () => document.removeEventListener('keydown', handleKeyDown);
  }, [onClose]);

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal-content" onClick={(e) => e.stopPropagation()}>
        <button className="modal-close" onClick={onClose}>
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <line x1="18" y1="6" x2="6" y2="18" />
            <line x1="6" y1="6" x2="18" y2="18" />
          </svg>
        </button>
        <img src={imageSrc} alt={`Pagina ${pageNumber}`} className="modal-image" />
        <div className="modal-footer">
          Pagina {pageNumber}
        </div>
      </div>

      <style>{`
        .modal-overlay {
          position: fixed;
          inset: 0;
          background: rgba(0, 0, 0, 0.9);
          display: flex;
          align-items: center;
          justify-content: center;
          z-index: 1000;
          padding: 24px;
        }

        .modal-content {
          position: relative;
          max-width: 95vw;
          max-height: 95vh;
          display: flex;
          flex-direction: column;
          align-items: center;
        }

        .modal-close {
          position: absolute;
          top: -40px;
          right: 0;
          background: none;
          border: none;
          color: white;
          padding: 8px;
          cursor: pointer;
          opacity: 0.8;
          transition: opacity 0.2s;
        }

        .modal-close:hover {
          opacity: 1;
        }

        .modal-image {
          max-width: 100%;
          max-height: calc(95vh - 80px);
          object-fit: contain;
          border-radius: var(--border-radius);
        }

        .modal-footer {
          color: white;
          padding: 12px;
          font-size: 14px;
          opacity: 0.8;
        }
      `}</style>
    </div>
  );
}

export default ImageModal;
